import { createGroupOwner } from "./creation/createGroupOwner";
import { createEmployee } from "./creation/createEmployee";
import { createDependent } from "./creation/createDependent";
import { login } from "./login";
import { forgetUserName } from "./forgetCredential/forgetUserName";
import { generatePasswordLink, changeForgetPassword } from "./forgetCredential/forgetPassword";
import { ownerSignUp } from "./registration/ownerSignUp";
import { memberSignUp } from "./registration/memberSignUp";
import { editGroupOwner, changePassword, editUserProfileInformation, enableAndDisableUserById } from "./updateUser";
import { memberChangePassword } from "./memberChangePassword";
import { editClaimVisibilityById } from "./editClaimVisibility";

export const auth = {
	createGroupOwner,
	createEmployee,
	createDependent,
	ownerSignUp,
	memberSignUp,
	login,
	forgetUserName,
	generatePasswordLink,
	changeForgetPassword,
	editGroupOwner,
	changePassword,
	editUserProfileInformation,
	enableAndDisableUserById,
	memberChangePassword,
	editClaimVisibilityById
};
